// components/EnergyConsumptionResults.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const EnergyConsumptionResults = ({ results }) => {
  // Format the unit energy consumption data for the chart
  const chartData = Object.entries(results.unitEnergyConsumption || {})
  .filter(([_, energy]) => typeof energy === 'number' || (typeof energy === 'object' && typeof energy.power === 'number'))
  .map(([unit, energy]) => {
    // Convert camelCase to Title Case for display
    const unitName = unit
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
    
    // Make sure you're always working with numbers
    const energyValue = typeof energy === 'number' ? energy : (energy.power || 0);
    
    return {
      name: unitName,
      energy: energyValue
    };
  });

  return (
    <div className="energy-results">
      <div className="summary-metrics">
        <div className="metric-card">
          <h4>Total Energy Consumption</h4>
          <div className="metric-value">{results.totalEnergyConsumption} MW</div>
        </div>
        
        <div className="metric-card">
          <h4>CO₂ Emissions</h4>
          <div className="metric-value">{results.totalCO2Emissions} tonnes/day</div>
        </div>
        
        <div className="metric-card">
          <h4>Specific Energy</h4>
          <div className="metric-value">{results.specificEnergyConsumption} kWh/kmol</div>
        </div>
      </div>
      
      <div className="energy-chart">
        <h3>Energy Consumption by Unit</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis label={{ value: 'Energy (MW)', angle: -90, position: 'insideLeft' }} />
            <Tooltip 
                formatter={(value) => {
                    if (typeof value === 'number') {
                    return [`${value.toFixed(2)} MW`, 'Energy'];
                    }
                    return ['N/A', 'Energy'];
                }} 
                />
            <Legend />
            <Bar dataKey="energy" name="Energy Consumption" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <div className="download-section">
        <button className="download-button">
          Download Detailed Report
        </button>
      </div>
    </div>
  );
};

export default EnergyConsumptionResults;